import { http } from '@/http/axios';
import {
  normalizeMissingElements,
  type ConversionRecommendation,
} from '@/lib/conversionRecommendations';

type ConversionRecommendationDto = {
  id: number;
  sessionId: number;
  webinarId: number;
  plannedDate: string;
  missingElements: string[];
};

export const conversionRecommendationsService = {
  list: async (workspaceId: number): Promise<ConversionRecommendation[]> => {
    const response = await http.get<ConversionRecommendationDto[]>(
      `/workspaces/${workspaceId}/conversion-recommendations`,
    );

    return response.data.map((item) => ({
      id: item.id,
      sessionId: item.sessionId,
      webinarId: item.webinarId,
      plannedDate: item.plannedDate,
      missingElements: normalizeMissingElements(item.missingElements ?? []),
    }));
  },

  updatePreference: async (workspaceId: number, disabled: boolean): Promise<boolean> => {
    const response = await http.put<{ disabled: boolean }>(
      `/workspaces/${workspaceId}/conversion-recommendations/preference`,
      { disabled },
    );

    return response.data.disabled;
  },
};
